import newService from "../../services/news"
import moment from "moment";

export default {
    created() {
        window.addEventListener("scroll", this.handleScroll);
        this.loading = true;
        this.getNewsList();
    },
    data() {
        return {
         perpage:12,
         pageSize: 12,
         newsList: [],
         total: 0,
         currentPage: 1,
         isLoadMore: false,
         loading: false
        }
    },
    methods: {
        onClickLink(url) {
            if(url) {
                window.open(url,'_blank')
            }
        },
         formatTime(time) {
            return moment(time).format("DD MMMM YYYY");
          },
        async getNewsList() {
            await newService.getNews({per_page: this.perpage}).then((res)=> {
               
                if(res && res.length > 0){
                    this.total = res.length;
                    // this.loading = false;
                    const oldLength = this.newsList.length;
                    res.map(async (item, index)=>  {
                       if((oldLength > 0 &&  index > (oldLength -1 ))|| oldLength==0) {
                        this.newsList.push(item);
                        const imageRes = await newService.getNewsImage(item.featured_media);
                        if(imageRes && imageRes.source_url) {
                          item.imageUrl =  imageRes.source_url;
                          this.newsList.splice(index,1,item);
                          if(this.newsList.length > 0 && this.newsList.findIndex((news)=> news.imageUrl==undefined) <0) {
                            this.loading = false;
                            if(this.isLoadMore) {
                              this.isLoadMore = false
                            }
                          }
                          
                        }
                       
                       
                      
                       }
                        
                    });


                }
            })
        },
    handleScroll(e) {
      if (
        window.innerHeight + window.pageYOffset >=
        (document.body.offsetHeight - 50)
      ) {
        this.loadPage();
      }
    },
     loadPage() {
      if (this.perpage > this.total) {
        this.isLoadMore = false;
      } else {
        if (this.perpage <= this.total && !this.isLoadMore && this.total > 0) {
          this.isLoadMore = true;
          setTimeout(() => {
            // this.isLoadMore = false;
            this.currentPage = this.currentPage + 1;
            this.perpage = this.pageSize + this.perpage;
            this.getNewsList();
           
          }, 2000);
        }

      }
    },
    }
}